import React, { useState, useContext, useEffect } from "react";
import { RootContext } from "../../RootContextProvider";

import { Select, Divider, Input, Tag, Modal, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import { createNewPage } from "../../utils/pages";
import "./SelectPages.css";
import ModalUpgradeLinks from "../Locker/ModalUpgradeLinks";
const { Search } = Input;
const { Option } = Select;

const SelectPages = ({ isMobile }) => {
  const { listPages, pages, account } = useContext(RootContext);
  let validator = new SimpleReactValidator();

  const [modalOpen, setModalOpen] = useState(false);
  const [pageName, setPageName] = useState();
  const [loading, setLoading] = useState(true);
  const [isAllowedToAddPages, setIsAllowedToAddPages] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  useEffect(() => {
    const setRestrictions = () => {
      if (account.IsPaying && account.Limitations > listPages.length) {
        setIsAllowedToAddPages(true);
      }
      setLoading(false);
    };
    setRestrictions();
    // eslint-disable-next-line
  }, [listPages]);

  const handleOk = (e) => {
    console.log(e);
  };

  const handleCancel = (e) => {
    console.log(e);
    setModalOpen(false);
  };

  const changePageContext = async (pageID) => {
    localStorage.setItem("pageToLoad", pageID);
    window.location.reload();
  };
  const createPage = async () => {
    try {
      console.log("Create new page");
      // validator
      console.log(pageName);
      validator.message(
        "pageName",
        pageName,
        "alpha_num_dash|required|min:4|max:30"
      );
      if (validator.allValid()) {
        setLoading(true);
        let res = await createNewPage(pageName);
        console.log(res);
        if (res.message !== "ok") {
          message.error("😅 Opsss, ce nom de page est déjà pris.");
        } else {
          localStorage.setItem("pageToLoad", res.data);
          window.location.replace("/links?status=pageCreated");
          setModalOpen(false);
        }
        setLoading(false);
      } else {
        message.error(
          "Le champ doit faire entre 4 et 30 caractères contenant seulement des chiffres et lettres"
        );
      }
    } catch (e) {
      message.error("Erreur lors du changement de nom de page.");
    }
  };

  if (!listPages || listPages.length === 0) {
    return <></>;
  } else {
    return (
      <>
        <Select
          style={{ width: 240 }}
          className={`${isMobile ? "select-pages-mobile" : "select-pages"}`}
          placeholder="custom dropdown render"
          disabled={loading}
          defaultValue={pages.PageName}
          onChange={(e) => {
            changePageContext(e);
          }}
          dropdownRender={(menu) => (
            <div>
              {menu}
              <Divider style={{ margin: "4px 0" }} />

              <div
                className={
                  isAllowedToAddPages
                    ? "new-page-drop"
                    : "new-page-drop-blocked"
                }
                onClick={() => {
                  isAllowedToAddPages
                    ? setModalOpen(true)
                    : setShowUpgradeModal(true);
                }}
              >
                <PlusOutlined /> Nouvelle page{" "}
                {!account.IsPaying ? (
                  <Tag color="#FDB62F" style={{ float: "right" }}>
                    PREMIUM
                  </Tag>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        >
          {listPages.map((page) => (
            <Option key={page.PageID} value={page.PageID}>
              {page.PageName}
            </Option>
          ))}
        </Select>
        <Modal
          footer={null}
          title=""
          visible={modalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
        >
          <div className="modal-container-new">
            <div className="add-new-page-title">Créer une nouvelle page</div>
            <Search
              prefix="https://linksight.me/"
              onChange={(e) => {
                setPageName(e.target.value);
              }}
              enterButton="Créer"
              size="large"
              loading={loading}
              onSearch={() => {
                createPage();
              }}
              // onClick={() => {

              // }}
            />
          </div>
        </Modal>
        <ModalUpgradeLinks
          setShowUpgradeModal={setShowUpgradeModal}
          showUpgradeModal={showUpgradeModal}
          subtitle="Créez jusqu'à 5 pages Linksight en passant PRO"
        />
      </>
    );
  }
};

export default SelectPages;
